import merge from 'lodash/merge'
import { createTheme, responsiveFontSizes } from '@mui/material'
import { THEMES } from './constants'
import { lightShadows, darkShadows } from './shadows'

const baseOptions = {
  direction: 'ltr',
  components: {
    MuiOutlinedInput: {styleOverrides: { root: {borderRadius: '10px'}}},
    MuiAvatar: {styleOverrides: {fallback: {height: '75%',width: '75%',},},},
    MuiButton: {styleOverrides: {root: {textTransform: 'none',borderRadius: '15px',},},},
  //   MuiTab: {styleOverrides: {root: {textTransform: 'none',borderRadius:'15px',
  //   border:'solid',borderWidth: '1.5px', minHeight:'33px', textAlign:'center', marginRight:'5px',
  // paddingTop:"0px", paddingBottom:'0px', paddingRight:'8px', paddingLeft:'8px' },},},
  //   MuiTabScrollButton: {styleOverrides: { root: {height:'33px',borderRadius:'10px', border:'solid', borderWidth: '1.5px', width:'fit-content',  }}},

    MuiCssBaseline: {styleOverrides: {'*': {
      boxSizing: 'border-box',},
      html: {MozOsxFontSmoothing: 'grayscale',WebkitFontSmoothing: 'antialiased',height: '100%',width: '100%',},
      body: {height: '100%',},
      '#root': {height: '100%',},
      '#nprogress .bar': {zIndex: '2000 !important',},},},
    MuiCardHeader: {defaultProps: {titleTypographyProps: {variant: 'h6',},},},
    MuiLinearProgress: {styleOverrides: {root: {borderRadius: 3,overflow: 'hidden',},},},
    MuiListItemIcon: {styleOverrides: {root: {minWidth: 'auto',marginRight: '16px',},},},
    MuiPaper: {styleOverrides: {root: {backgroundImage: 'none',},},},
  },

  typography: {
    button: {fontWeight: 600,},
    fontFamily:'-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    h1: {fontWeight: 600,fontSize: '3.5rem',},
    h2: {fontWeight: 600,fontSize: '3rem',},
    h3: {fontWeight: 600,fontSize: '2.25rem',},
    h4: {fontWeight: 600,fontSize: '2rem',},
    h5: {fontWeight: 600,fontSize: '1.5rem',},
    h6: {fontWeight: 600,fontSize: '1.125rem',},
    
    overline: {fontWeight: 600,},}
  }

const themesOptions = {
  [THEMES.LIGHT]: {
    components: {
      MuiInputBase: {styleOverrides: {input: {'&::placeholder': {opacity: 0.86,color: '#42526e',},},},},
      MuiFormHelperText: {styleOverrides: {root: {fontWeight: 'bold'}}}
    },
    palette: {
      white: '#fff',
      darkGrey: '#5B5B5B',
      disabled: '#d6d7d9',
      overlay: 'rgba(0, 0, 0, 0.50)',
      boxShadow: '#6b778c',
      box: '#663e83',
      white: '#fff',
      secondaryTitle: 'red',
      svg: '#5b5b5b',
      selected: {chip: '#86469a',},
      orderStatus: {isPaid: '#1FB719',notPaid: '#EB4242',},
      userMenu: {icons: 'white',},
      icons: {main: '#000', secondary:'#fff'},
      pageTitle: '#5b5b5b',
      rateStar: '#97c24c',
      navItems: {active: {subText: "#1083c6",text: '#ffff',arrow: 'white'},arrow: 'black'},
      menuButton: {activeBackgroundColor: '#dadada',backgroundColor: '#ffffff',},
      titleBox: {contrastText: '#ffffff',backgroundColor: '#723087',},
      action: {active: '#6b778c',},
      background: {default: '#f4f5f7',paper: '#ffffff',hover: '#e5dee7',selected: '#eee3f6',chipSelected: '#c0a9c6'},
      error: {contrastText: '#ffffff',main: '#ff0000',},
      secondary: {contrastText: '#fff',main: '#5b5b5b',},
      mode: 'light',
      primary: {contrastText: '#ffffff',main: '#1083c6',},
      success: {contrastText: '#ffffff',main: '#63AF58',},
      text: {primary: '#000',secondary: 'grey',third:'#686868'},
      warning: {contrastText: '#ffffff',main: '#C82323',},
      card: {contrastText: '#000000',main: '#F6F8FB'},
      box: {contrastText: '#000',main: '#E9E9E9'},
      bg: {contrastText: '#000',main: '#f4f5f7'},
      third:{contrastText: '#000',main: '#fff',},
      darkRed: {contrastText: '#000000',main: '#C82323'},
  
    },
    shadows: lightShadows,
  },
  [THEMES.DARK]: {
    components: {
      MuiTableHead: {
        root: {
          borderRadius: 5,
        }

      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: '1px solid rgba(145, 158, 171, 0.24)',
          },
        },
      },
    },
    palette: {
      background: {
        default: '#171c24',
        paper: '#222b36',
      },
      divider: 'rgba(145, 158, 171, 0.24)',
      box: '#b975e0',
      titleBox: {
        contrastText: '#ffffff',
        backgroundColor: '#688eff',
      },
      error: {
        contrastText: '#ffffff',
        main: '#f44336',
      },
      mode: 'dark',
      primary: {
        contrastText: '#ffffff',
        main: '#7648A3',
      },
      white: {
        contrastText: '#060606',
        main: '#ffffff',
      },
      success: {
        contrastText: '#ffffff',
        main: '#4caf50',
      },
      text: {
        primary: '#ffffff',
        secondary: '#919eab',
      },
      warning: {
        contrastText: '#ffffff',
        main: '#ff9800',
      },
      card: {contrastText: '#ffffff',main: '#171c24'},
      box: {contrastText: '#ffffff',main: '#000'},
      bg: {contrastText: '#fff',main: '#688eff'},
      icons: {main: '#fff', secondary:'#000'},
    },
    shadows: darkShadows,
  },
  [THEMES.NATURE]: {
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: '1px solid rgba(145, 158, 171, 0.24)',
          },
        },
      },
    },
    palette: {
      background: {
        default: '#1c2531',
        paper: '#293142',
      },
      divider: 'rgba(145, 158, 171, 0.24)',
      error: {
        contrastText: '#ffffff',
        main: '#f44336',
      },
      mode: 'dark',
      primary: {
        contrastText: '#ffffff',
        main: '#01ab56',
      },
      success: {
        contrastText: '#ffffff',
        main: '#4caf50',
      },
      white: {
        contrastText: '#060606',
        main: '#ffffff',
      },
      text: {
        primary: '#ffffff',
        secondary: '#919eab',
      },
      warning: {
        contrastText: '#ffffff',
        main: '#ff9800',
      },
    },
    shadows: darkShadows,
  },
}

export const createCustomTheme = (config = {}) => {
  let themeOptions = themesOptions[config.theme]

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`))
    themeOptions = themesOptions[THEMES.LIGHT]
  }

  let theme = createTheme(
    merge(
      {},
      baseOptions,
      themeOptions,
      // {
      //   ...(config.roundedCorners && {
      //     shape: {
      //       borderRadius: 16,
      //     },
      //   }),
      // },
      {
        direction: config.direction,
      },
    ),
  )

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme)
  }

  return theme
}
